<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <h3>Документ</h3>
            </v-flex>
            <v-flex xs12>
                <v-tabs
                        v-model="tab"
                >
                    <v-tab href="#tab-1">
                        Основные данные
                    </v-tab>
                    <v-tab-item
                            :value="'tab-1'">
                        <v-card>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model.trim="card.software_name"
                                                    label="Наименование программы"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field
                                                    v-model.trim="card.price"
                                                    label="Стоимость"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field
                                                    v-model.trim="card.quantity"
                                                    label="Количество"
                                                    type="number"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model="fullDocument"
                                                    label="Документ"
                                                    readonly
                                                    :loading="listLoading.includes('ASDocumentFetchCard_' + card.document)"
                                                    :append-outer-icon="'mdi-select-search'"
                                                    @click:append-outer="$router.push({name: 'software_select_document'})"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model.trim="card.install_loc"
                                                    label="Место установки"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model.trim="card.responsible"
                                                    label="Ответственный за программный продукт"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model.trim="card.inventory_year"
                                                    label="Год инвентаризации"
                                                    type="number"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model="card.date_end"
                                                    label="Дата списания"
                                                    type="date"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model.trim="card.reason_end"
                                                    label="Причина списания"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                        </v-card>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                    icon
                                    large
                                    class="mx-2"
                                    @click.native="close"
                            >
                                <v-icon>mdi-cancel</v-icon>
                            </v-btn>
                            <v-btn
                                    icon
                                    large
                                    class="mx-2"
                                    @click.native="save()"
                            >
                                <v-icon>mdi-content-save</v-icon>
                            </v-btn>
                            <v-btn
                                    icon
                                    large
                                    class="mx-2"
                                    @click.native="deleteCard()"
                            >
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-tab-item>
                    <v-tab href="#tab-2">
                        Системные данные
                    </v-tab>
                    <v-tab-item
                            :value="'tab-2'"
                    >
                        <system-form :system-info="card"></system-form>
                    </v-tab-item>
                </v-tabs>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import SystemForm from '../../common/systemForm'
export default {
  name: 'cardSoftware',
  components: { SystemForm },
  data () {
    return {
      tab: 1
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    card () {
      return this.$store.getters['ASSoftware/card']
    },
    fullDocument () {
      return this.$store.getters['ASDocument/fullCard']
    }
  },
  methods: {
    initialize () {
      if (this.$route.params.id === 'new') {
        this.$store.commit('ASSoftware/createCard')
      } else {
        this.$store.dispatch('ASSoftware/fetchCard', this.$route.params.id)
      }
    },
    save (status) {
      this.$store.dispatch('ASSoftware/insertCard', this.card)
        .then(() => {
          this.close()
        })
    },
    close () {
      this.$store.commit('ASDocument/createCard')
      this.$router.go(-1)
    },
    deleteCard (id) {
      this.$store.dispatch('ASSoftware/deleteCard', this.card.id)
        .then(() => {
          this.$router.go(-1)
        })
    }
  },
  created: function () {
    console.log('this.card.id60', '' + this.card.id, 'this.$route.params.id', '' + this.$route.params.id, ('' + this.card.id) !== ('' + this.$route.params.id))

    if (('' + this.card.id) !== ('' + this.$route.params.id)) {
      if (this.$route.params.id === 'new') {
        this.$store.commit('ASSoftware/createCard')
      } else {
        this.$store.dispatch('ASSoftware/fetchCard', this.$route.params.id)
          .then(() => {
            this.$store.dispatch('ASDocument/fetchCard', { id: this.card.document })
          })
      }
    }
  }
}
</script>
